<template src="../templates/normal_fcont_118_jp.html"/>

<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreativePrint from '../components/CreativePrint'

import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadCreative from '../components/AppDownloadCreative';
export default {
  name: 'app',
  components: {
    LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,FuncSearchGalleryQR,CreativePrint,
   AppDownloadCreative
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  }

};
</script>
<style />
